import React, { useRef, useState } from "react";
import { ImagePlus, Loader2 } from "lucide-react";
import { hubImageUrl, uploadHubImage } from "@/api";
import { errMsg } from "@/hooks/useHubSession";

export function ImageUpload({ label, value, onChange, withSession, showToast, aspect = "h-32", tid }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!["image/jpeg", "image/png", "image/webp"].includes(f.type)) return showToast("Use a JPG, PNG or WEBP image", "error");
    if (f.size > 5 * 1024 * 1024) return showToast("Image must be under 5 MB", "error");
    setBusy(true);
    try { onChange(await withSession((t) => uploadHubImage(t, f))); } catch (err) { showToast(errMsg(err, "Upload failed"), "error"); }
    setBusy(false);
  };
  return (
    <div>
      <div className="text-sm text-slate-300 mb-1">{label}</div>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={tid}
        className={`w-full ${aspect} rounded-2xl border-2 border-dashed border-[#2A2E45] hover:border-orange-500/60 transition-colors overflow-hidden flex items-center justify-center bg-[#12131C]`}>
        {busy ? <Loader2 className="animate-spin text-orange-400" />
          : value ? <img src={hubImageUrl(value)} alt={label} className="w-full h-full object-cover" />
          : <span className="flex items-center gap-2 text-slate-500 text-sm"><ImagePlus size={18} /> Upload image</span>}
      </button>
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={pick} data-testid={`${tid}-input`} />
    </div>
  );
}
